/**
  * 发送轨迹埋点事件
  * @param {string | number} eventId 事件ID
  * @param {string} category 事件类别category
  * @param {string} action 事件类型
  * @param {string} label 事件label
  * @param {string} value 事件值
  */
const sendTrackEvent = (eventId,category, action, label, value, pageUrl) => {
    let valueArr = [];
    for (let key in value) {
        if (value[key] !== '' && value[key] !== undefined) {
            valueArr.push(key + ':' + value[key]);
        } else {
            valueArr.push(key);
        }
    }
    let valueStr = valueArr.join('^');
    const sendEvent = window._tcTraObj && window._tcTraObj._tcTrackEventNew;
    if (!sendEvent) {
        setTimeout(
            () => sendTrackEvent(eventId, category, action, label, valueStr, pageUrl = location.href),
            200,
        );
        return;
    }
    return sendEvent(category, action, label, valueStr, eventId, pageUrl = location.href);
}

export default sendTrackEvent;